import { useEffect } from "react";
import { useContextTranslate } from "../Translate/ContextProvider";

function Message() {
  const { message, setMessage } = useContextTranslate();

  useEffect(() => {
    if (message) {
      setTimeout(() => {
        setMessage("");
      }, 4000);
    } else {
      setMessage("");
    }
  }, [message]);

  return (
    <>
      {
        <div
          className={`fixed transition-all right-7 bg-white border-t-4 border-Purple py-5 px-7 shadow-lg z-50  ${
            message ? "bottom-10 " : "-bottom-full"
          }`}
        >
          <p>{message}</p>
        </div>
      }
    </>
  );
}

export default Message;
